import { render, staticRenderFns } from "./CreateStoreItemView.vue?vue&type=template&id=4474298c&scoped=true&"
import script from "./CreateStoreItemView.vue?vue&type=script&lang=ts&"
export * from "./CreateStoreItemView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4474298c",
  null
  
)

export default component.exports